import React from 'react';
import PropTypes from 'prop-types';
import { Field, useFormikContext } from 'formik';
import { useIntl, defineMessages } from 'react-intl';
import {
  DropdownComponent,
  InputTextComponent,
  TextAreaComponent,
} from '../../components/prime-formik';

const i18nMessages = defineMessages({
  itemType: {
    id: 'menu.item-bank-management.item-type',
    defaultMessage: 'Item Type',
  },
  itemAnswerType: {
    id: 'menu.item-bank-management.item-answer-type',
    defaultMessage: 'Item Answer Type',
  },
  itemCode: {
    id: 'menu.item-bank-management.item-code',
    defaultMessage: 'Item Code',
  },
  itemText: {
    id: 'menu.item-bank-management.item-text',
    defaultMessage: 'Item Text',
  },
  valence: {
    id: 'menu.item-bank-management.valence',
    defaultMessage: 'Valence',
  },
  supportText: {
    id: 'menu.item-bank-management.support-text',
    defaultMessage: 'Support Text',
  },
});

const AddBehaviorItem = ({
  section,
  availableItemTypes,
  availableItemAnswerTypes,
  availableValenceTypes,
  availableContexts,
}) => {
  const { formatMessage } = useIntl();

  const { values } = useFormikContext();

  const itemTypeOptions = availableItemTypes
    .map(itemType => ({
      value: itemType,
      label: itemType,
    }));

  const filteredItemAnswerTypes = availableItemAnswerTypes
    .filter(itemAnswerType => itemAnswerType.itemType === values.type && itemAnswerType.sectionCode === section);

  const itemAnswerTypeOptions = filteredItemAnswerTypes
    .map(itemAnswerType => ({
      value: itemAnswerType.itemAnswerTypeId,
      label: itemAnswerType.itemAnswerType,
    }));

  const valenceTypeOptions = availableValenceTypes
    .map(valenceType => ({
      value: valenceType,
      label: valenceType,
    }));

  const filteredContexts = availableContexts
    .filter(context => context.itemType === values.type && context.sectionCode === section);

  const contextOptions = filteredContexts
    .map(context => ({
      value: context.id,
      label: context.code,
    }));

  return (
    <>
      <Field
        type="hidden"
        value={section}
        name="sectionCode"
      />
      <div className="items-controls">
        <div>
          <div className="input-label">{formatMessage(i18nMessages.itemType)}</div>
          <div>
            <Field
              id="type"
              name="type"
              component={DropdownComponent}
              options={itemTypeOptions}
            />
          </div>
        </div>
        <div>
          <div className="input-label">{formatMessage(i18nMessages.itemAnswerType)}</div>
          <div>
            <Field
              id="answerType"
              name="answerType"
              component={DropdownComponent}
              options={itemAnswerTypeOptions}
            />
          </div>
        </div>
      </div>

      <div className="behavior-item-details-controls">
        <div>
          <div className="input-label">{formatMessage(i18nMessages.itemCode)}</div>
          <div>
            <Field
              id="code"
              name="code"
              component={InputTextComponent}
            />
          </div>
        </div>
        <div>
          <div className="input-label">{formatMessage(i18nMessages.itemText)}</div>
          <div>
            <Field
              id="text"
              name="text"
              component={TextAreaComponent}
            />
          </div>
        </div>
        <div>
          <div className="input-label">{formatMessage(i18nMessages.valence)}</div>
          <div>
            <Field
              id="valence"
              name="valence"
              component={DropdownComponent}
              options={valenceTypeOptions}
            />
          </div>
        </div>
      </div>


      <div className="context-option-controls">
        <div className="input-label">{formatMessage(i18nMessages.supportText)}</div>
        <div>
          <Field
            id="contextId"
            name="contextId"
            component={DropdownComponent}
            options={contextOptions}
          />
        </div>
      </div>
    </>
  );
};

AddBehaviorItem.propTypes = {
  section: PropTypes.string.isRequired,
  availableItemTypes: PropTypes.arrayOf(PropTypes.any).isRequired,
  availableItemAnswerTypes: PropTypes.arrayOf(PropTypes.any).isRequired,
  availableValenceTypes: PropTypes.arrayOf(PropTypes.any).isRequired,
  availableContexts: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default AddBehaviorItem;
